export const TECH_APP_PROFILE = "TECH_APP_PROFILE";
export const TECH_ORDER_TAB = "TECH_ORDER_TAB";
export const TECH_ORDER_OBJ = "TECH_ORDER_OBJ";
export const TECH_ALLOWED_ACTIONS = "TECH_ALLOWD_ACTIONS";
export const TECH_APP_TRANSACTIONS = "TECH_APP_TRANSACTIONS";
export const TECH_APP_TICKET_STATUS = "TECH_APP_TICKET_STATUS";
export const TECH_APP_TICKET_DATA = "TECH_APP_TICKET_DATA";
export const TECH_APP_UNREAD_MESSAGES = "TECH_APP_UNREAD_MESSAGES";
export const TECH_APP_SHOW_UNREAD = "TECH_APP_SHOW_UNREAD";
export const TECH_APP_HINTS = "TECH_APP_HINTS";
export const TECH_APP_SETTINGS = "TECH_APP_SETTINGS";

export const setProfileData = (profileData) => {
  return {
    type: TECH_APP_PROFILE,
    payload: profileData,
  };
};

export const setTechOrderTab = (techOrderTab) => {
  return {
    type: TECH_ORDER_TAB,
    payload: techOrderTab,
  };
};

export const setOrderObj = (orderObj) => {
  return {
    type: TECH_ORDER_OBJ,
    payload: orderObj,
  };
};
export const setAllowedActions = (actions) => {
  return {
    type: TECH_ALLOWED_ACTIONS,
    payload: actions,
  };
};

export const setTransactions = (transaction) => {
  return {
    type: TECH_APP_TRANSACTIONS,
    payload: transaction,
  };
};

export const setTicketStatus = (status) => {
  return {
    type: TECH_APP_TICKET_STATUS,
    payload: status,
  };
};

export const setTicketData = (data) => {
  return {
    type: TECH_APP_TICKET_DATA,
    payload: data,
  };
};

export const setUnreadMessages = (data) => {
  return {
    type: TECH_APP_UNREAD_MESSAGES,
    payload: data,
  };
};

export const setShowUnread = (data) => {
  return {
    type: TECH_APP_SHOW_UNREAD,
    payload: data,
  };
};

export const setHints = (data) => {
  return {
    type: TECH_APP_HINTS,
    payload: data,
  };
};

export const setSettings = (data) => {
  return {
    type: TECH_APP_SETTINGS,
    payload: data,
  };
};